import { FONTS_WITH_TINYMCE_GOOGLE_FONTS } from '@opengov/stories-shared/constants';
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import React from 'react';

import { ISettings, IStoriesSettingsMessages } from '../../../../types';
import { styles } from './FontSelectors.styles';

export type IFontSelectorsProps = {
  messages: IStoriesSettingsMessages;
  settings: ISettings;
  updateSettingsProps(newSettingsProps: Partial<ISettings>): void;
};

type IFont = { id: string; name: string; fallback: string };

const fonts: IFont[] = FONTS_WITH_TINYMCE_GOOGLE_FONTS;

export const FontSelectors = ({ messages, settings, updateSettingsProps }: IFontSelectorsProps) => {
  const { headline, paragraph } = settings.brand.fonts;

  const getFont = (id: string) => fonts.find((f) => f.id === id) ?? null;

  const handleChange = (section: string) => (_e: React.SyntheticEvent, option: IFont | null) => {
    if (!option) return;
    updateSettingsProps({
      brand: {
        ...settings.brand,
        fonts: { ...settings.brand.fonts, [section]: option.id }
      }
    });
  };

  return (
    <Box sx={styles.container}>
      <Typography variant="h5" sx={styles.heading}>{messages.fonts}</Typography>
      <Typography variant="body2" sx={styles.description}>{messages.customFontText}</Typography>

      <Autocomplete
        disableClearable
        options={fonts}
        getOptionLabel={(option) => option.name}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        value={getFont(headline as string)}
        onChange={handleChange('headline')}
        className="test-font-headline"
        renderOption={(props, option) => <li {...props} key={option.id}>{option.name}</li>}
        renderInput={(params) => (
          <TextField {...params} size="small" label={messages.headlineFont} inputProps={{ ...params.inputProps, className: 'no-format' }} />
        )}
      />

      <Autocomplete
        disableClearable
        options={fonts}
        getOptionLabel={(option) => option.name}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        value={getFont(paragraph as string)}
        onChange={handleChange('paragraph')}
        className="test-font-body"
        renderOption={(props, option) => <li {...props} key={option.id}>{option.name}</li>}
        renderInput={(params) => (
          <TextField {...params} size="small" label={messages.paragraphFont} inputProps={{ ...params.inputProps, className: 'no-format' }} />
        )}
      />
    </Box>
  );
};
